import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Notification } from '@sleipai/sleip-models';

export type ActiveRecordingNotificationState = EntityState<Notification>;

export const activeRecordingNotificationAdapter: EntityAdapter<Notification> =
  createEntityAdapter<Notification>({
    selectId: (notification: Notification) => notification.resourceId ?? notification.id ?? '',
  });

export const {
  selectIds: selectActiveRecordingNotificationIdsAdapter,
  selectEntities: selectActiveRecordingNotificationEntitiesAdapter,
  selectAll: selectAllActiveRecordingNotificationsAdapter,
  selectTotal: selectActiveRecordingNotificationsTotalAdapter,
} = activeRecordingNotificationAdapter.getSelectors();
